import React from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Text, TextProps } from '../text';

export const FormSubLabel = forwardRef<TextProps, 'label'>(
  (props: TextProps, ref) => {
    const formSubLabelProps = {
      mt: 0,
      ...props,
    };
    return (
      <Text
        size="body-md"
        variant="text-secondary"
        ref={ref}
        {...formSubLabelProps}
      />
    );
  }
);
